import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import IconPen from '../../../../icons/pen';
import { connect } from 'react-redux';
import LoadMask from '../../../Utils/LoadMask';
import { loadVendor, updateVendor } from '../../../../../redux/modules/vendors';
import VendorForm from "../forms/vendor";
import Modal from './modal';


const VendorHeader = (props) => {
    const {
        id,
        loading = false,
        loadVendor,
        updateVendor,
        vendor
    } = props;

    const [modalVendor, setModalVendor] = React.useState(false);
    const [editVendor, setEditVendor] = React.useState(null);

    React.useEffect(() => {
        if (id)
            loadVendor(id);
    }, [id]);

    const onOpenModalVendor = () => {
        setEditVendor({
            name: vendor.name,
            contact_email: vendor.contact_email,
            active: vendor.active,
        });
        setModalVendor(true);
    }

    const onCloseModalVendor = () => {
        setEditVendor(null);
        setModalVendor(false);
    }

    const onSubmitVendorForm = async (values) => {
        const updatedVendor = await updateVendor(id, values);
        if (updatedVendor)
            onCloseModalVendor();
    }

    if (!id)
        return (
            <div className="">
                <h5>No vendor ID has been provided.</h5>
            </div>
        )

    return (
        <React.Fragment>
            <Modal
                open={modalVendor}
                onClose={onCloseModalVendor}
                styles={{
                    modal: { borderRadius: 12, maxWidth: 500 }
                }}
            >
                <Modal.Header title="Edit Vendor"/>
                <div className="p-4">
                    <VendorForm
                        showBtns={false}
                        id="vendor-update-form"
                        onSubmit={onSubmitVendorForm}
                        initialValues={editVendor}
                    />
                </div>
                <Modal.Footer idForm="vendor-update-form" />
            </Modal>
            <LoadMask loading={loading} blur>
                <div className="header-card mb-4 p-4">
                    <div className="d-flex justify-content-between mb-3">
                        <span className="h3 fw-600 mb-0">
                            {vendor.name}
                        </span>
                        <div>
                            <button type="button"
                                className="btn btn-outline-primary border-danger d-flex align-items-center"
                                onClick={onOpenModalVendor}
                            >
                                <IconPen className="vendor-icon"/>
                                <span className="h6 fw-600 mb-0 ml-2 py-1">
                                    Edit Vendor
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap"
                        style={{ gap: 24 }}
                    >
                        <div className="d-flex flex-column">
                            <small className="text-muted mb-1 fw-600">
                                CONTACT EMAIL
                            </small>
                            <span className="h6 mb-0 fw-500">
                                {vendor.contact_email}
                            </span>
                        </div>
                        <div className="d-flex flex-column">
                            <small className="text-muted mb-1 fw-600">
                                STATUS
                            </small>
                            <span className={classNames("badge badge-pill px-2 fw-500", {
                                "badge-success": vendor.active,
                                "badge-secondary": !vendor.active,
                            })} >
                                {vendor.active
                                    ? 'Active'
                                    : 'Inactive'
                                }
                            </span>
                        </div>
                        <div className="d-flex flex-column">
                            <small className="text-muted mb-1 fw-600">
                                TOTAL DRIVERS
                            </small>
                            <span className="h6 mb-0 fw-500">
                                {vendor.user_count}
                            </span>
                        </div>
                        <div className="d-flex flex-column">
                            <small className="text-muted mb-1 fw-600">
                                CREATED
                            </small>
                            <span className="h6 mb-0 fw-500">
                                {vendor.date_created
                                    ? moment(vendor.date_created).format('MMM DD, YYYY')
                                    : 'NA'
                                }
                            </span>
                        </div>
                    </div>
                </div>
            </LoadMask>
        </React.Fragment>
    )
}

const mstp = (state) => ({
    loading: state.vendors.loading_vendor,
    vendor: state.vendors.vendor,
});

const mdtp = {
    loadVendor,
    updateVendor
}

export default connect(mstp, mdtp)(VendorHeader);
